import React from "react";

const Signout = () => <div>Signout</div>;

export default Signout;
